<!-- 维修表单页面 -->
<template>
  <div
    class="repair-base"
    v-track="{
      act: 'show',
      params: { cfrom: '01|01|079|001', type: type }
    }"
  >
    <!-- 内容区域 -->
    <div class="repair-base-wrapper">
      <div class="repair-base-content" :class="{ 'bottom-fixed': !isInViewport }">
        <holidayTips></holidayTips>
        <!-- 寄修订单 -->
        <oldOrder v-if="type == 2"></oldOrder>
        <!--  选择维修设备  -->
        <selectModel></selectModel>
        <!--  选择故障类型  -->
        <selectProblem></selectProblem>
      </div>
      <div class="split-line" id="split-line"></div>
      <!-- 底部bar -->
      <bottomBar
        :class="{ fixed: !isInViewport }"
        @goNext="goNext"
        @showPricePopup="showPricePopup"
      ></bottomBar>
    </div>
    <!-- 页面弹层 -->
    <servicePopup ref="pricePopup" :title="'预估总费用明细'">
      <pricePopup @hidePricePopup="hidePricePopup"></pricePopup>
    </servicePopup>
  </div>
</template>

<script>
import oldOrder from './components/old-order/index.vue'
import servicePopup from '@/components/service-popup/index.vue'
import bottomBar from './components/bottom-bar/index.vue'
import selectModel from './components/select-model/index.vue'
import selectProblem from './components/select-problem/index.vue'
import pricePopup from './components/price-popup/index.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import { getUserMobile } from '@/views/repair/confirm/api'
import holidayTips from '@/views/repair/introduction/components/holiday-tips/index.vue'
import api from '@/views/repair/introduction/api'
import clientEnv from 'utils/clientEnv'

export default {
  name: 'repairBase',
  components: {
    oldOrder,
    bottomBar,
    servicePopup,
    selectModel,
    selectProblem,
    pricePopup,
    holidayTips
  },
  data() {
    return {
      type: 0,
      beginTime: +new Date(),
      // 是否进入视口
      isInViewport: false
    }
  },
  created() {
    this.type = this.repairType || Number(this.$route.params.type)
    // 判断是否是四大维修
    if (this.type && (this.type == 1 || this.type == 2 || this.type == 3 || this.type == 6)) {
      this.SET_REPAIR_TYPE(this.type)
      this.setTitle()
    } else {
      location.href = 'https://www.vivo.com.cn/404'
    }
    this.getPriceTips()
  },
  computed: {
    ...mapState('repair', ['userPhone', 'addressList', 'repairType', 'isWeChatApp']),
    isShowHeader() {
      return !clientEnv.isVivoApp && !this.isWeChatApp
    }
  },
  mounted() {
    // 寄修需要查询历史订单
    if (this.type == 2) {
      this.getOldOrder()
    }
    this.getUserPhone()
    this.getAddressList()
    // 不展示头尾的话，不需要监听
    if (this.isShowHeader) {
      // 监听是否进入视口
      const observer = new IntersectionObserver(this.handleIntersection)
      // 监视目标元素
      observer.observe(document.querySelector('#split-line'))
    } else {
      this.isInViewport = false
    }
  },
  methods: {
    ...mapMutations('repair', [
      'RESET_STATE',
      'SET_REPAIR_TYPE',
      'SET_USER_PHONE',
      'SET_HAS_OLD_ORDER',
      'SET_PRICE_TIPS'
    ]),
    ...mapActions('repair', [
      'initMap',
      'getSiteList',
      'getTimeList',
      'getAddressList',
      'getOldOrder'
    ]),
    setTitle() {
      setTimeout(() => {
        if (this.repairType == 1) {
          document.title = '预约服务'
        } else if (this.repairType == 2) {
          document.title = '寄修服务'
        } else if (this.repairType == 3) {
          document.title = '上门维修'
        } else if (this.repairType == 6) {
          document.title = '同城快修'
        }
      }, 50)
    },
    // 获取账号关联手机号
    getUserPhone() {
      if (!this.userPhone) {
        getUserMobile()
          .then(res => {
            if (res.code === 0) {
              this.SET_USER_PHONE(res.data)
            } else {
              console.log(res.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    getPriceTips() {
      api
        .getResource({
          positionKey: 'cost_tips'
        })
        .then(res => {
          if (res.code === 0) {
            const data = res.data
            if (data && data.length > 0) {
              this.SET_PRICE_TIPS(res.data[0])
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 监听元素是否在视口中
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isInViewport = true
          // 在视口中的逻辑处理
        } else {
          const element = document.getElementById('split-line')
          const distanceToTop = element && element.getBoundingClientRect()?.top
          // 从视口上面离开
          if (distanceToTop > 10) {
            this.isInViewport = false
            // 不在视口中的逻辑处理
          }
        }
      })
    },
    // 下一步
    goNext() {
      this.$track({
        cfrom: '01|03|079|003',
        type: this.type,
        duration: +new Date() - this.beginTime
      })
      // 上门服务切换机型后需要重新匹配网点
      if (this.repairType == 3) {
        this.RESET_STATE('pickupAddress')
        this.RESET_STATE('repairTimeList')
        this.RESET_STATE('homeReapairSite')
        this.RESET_STATE('selectedTime')
      }
      this.$router.push(`/service/s/repair/confirm/${this.type}`)
    },
    // 展示配件价格
    showPricePopup() {
      this.$track({
        cfrom: '01|03|079|002',
        type: this.type
      })
      this.$nextTick(() => {
        this.$refs.pricePopup.openPopup()
      })
    },
    // 隐藏配件价格
    hidePricePopup() {
      this.$nextTick(() => {
        this.$refs.pricePopup.closePopup()
      })
    }
  },
  beforeRouteUpdate() {
    this.setTitle()
  }
}
</script>

<style lang="scss" scoped>
.repair-base {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .repair-base-wrapper {
    position: relative;
    padding-bottom: 78px;
  }

  .split-line {
    position: absolute;
    height: 1px;
    z-index: -1;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .repair-base-content {
    padding: 16px 0 0;
    box-sizing: border-box;
    flex: 1;
    overflow-y: auto;

    .holiday-tips {
      margin-top: 0;
      margin-bottom: 12px;
    }
  }
}
</style>
